import React, { useEffect, useState } from 'react'

import { Rights } from 'app/accountUserContextConstants'
import { getWorkspaceAccount } from 'app/GlobalStaticState'
import { openChat } from 'app/PylonChatBot'
import { useAccountUserContext } from 'app/useAccountUserContext'

import { Box } from 'ui/components/Box'
import { Button } from 'ui/components/Button'
import {
    Modal,
    ModalContent,
    ModalContentInner,
    ModalFooter,
    ModalHeader,
} from 'ui/components/Modal'
import { Body } from 'ui/components/Text'

const AstraTrialBlocker = () => {
    const [isOpen, setIsOpen] = useState(false)
    const { hasRight } = useAccountUserContext()

    useEffect(() => {
        const isSupportLogin = localStorage.getItem('support_login') === 'true'
        const workspaceAccount = getWorkspaceAccount()

        if (!workspaceAccount) return

        if (!isSupportLogin && workspaceAccount.options?.show_astra_sunset_block_screen) {
            setIsOpen(true)
        } else {
            setIsOpen(false)
        }
    }, [])

    return (
        <Box>
            <Modal open={isOpen}>
                <ModalContent>
                    <Box display="flex" justifyContent="center" mt="xl">
                        <Box
                            as="img"
                            src="/static/media/empty-state-calendar.svg"
                            alt="Calendar illustration"
                            width="33%"
                            height="33%"
                            p="l"
                        />
                    </Box>
                    <ModalHeader showCloseButton={false} title="Free trial ended" />
                    <ModalContentInner justifyContent="center" alignItems="center">
                        {hasRight(Rights.ContactSupport) ? (
                            <Body textAlign="center">Please contact support for assistance.</Body>
                        ) : (
                            <Body textAlign="center">
                                Please contact your workspace administrator if you still require
                                access.
                            </Body>
                        )}
                    </ModalContentInner>

                    {hasRight(Rights.ContactSupport) && (
                        <ModalFooter>
                            <Box display="flex" flexDirection="column" gap="m" width="full">
                                <Button fullWidth size="l" variant="primary" onClick={openChat}>
                                    Contact Support
                                </Button>
                            </Box>
                        </ModalFooter>
                    )}
                </ModalContent>
            </Modal>
        </Box>
    )
}

export default AstraTrialBlocker
